"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breed = void 0;
var profile_1 = require("../../schemas/profile");
var common_1 = require("../common");
var ChangeCase = require("change-case");
var Breed = /** @class */ (function (_super) {
    __extends(Breed, _super);
    function Breed(name, props) {
        if (props === void 0) { props = {}; }
        return _super.call(this, __assign(__assign({}, Breed.defaultProps(name, props.size || profile_1.BreedSize.MEDIUM, props.breedGroup || profile_1.BreedGroup.MIXED_BREED_DOGS)), props)) || this;
    }
    Breed.defaultParentCharacteristic = function () {
        return {
            rating: {
                value: 0,
                max: 5
            },
            name: '',
            children: []
        };
    };
    Breed.defaultChildCharacteristic = function () {
        return {
            rating: {
                value: 0,
                max: 5
            },
            parent: profile_1.ParentBreedCharacteristic.UNKNOWN
        };
    };
    Breed.defaultCharacteristics = function () {
        return {
            adaptability: __assign(__assign({}, Breed.defaultParentCharacteristic()), { adaptsWellToApartmentLiving: Breed.defaultChildCharacteristic(), goodForNoviceOwners: Breed.defaultChildCharacteristic(), sensitivityLevel: Breed.defaultChildCharacteristic(), toleratesBeingAlone: Breed.defaultChildCharacteristic(), toleratesColdWeather: Breed.defaultChildCharacteristic(), toleratesHotWeather: Breed.defaultChildCharacteristic() }),
            allAroundFriendliness: __assign(__assign({}, Breed.defaultParentCharacteristic()), { affectionateWithFamily: Breed.defaultChildCharacteristic(), incrediblyKidFriendlyDogs: Breed.defaultChildCharacteristic(), dogFriendly: Breed.defaultChildCharacteristic(), friendlyTowardStrangers: Breed.defaultChildCharacteristic() }),
            healthGrooming: __assign(__assign({}, Breed.defaultParentCharacteristic()), { amountOfShedding: Breed.defaultChildCharacteristic(), droolingPotential: Breed.defaultChildCharacteristic(), easyToGroom: Breed.defaultChildCharacteristic(), generalHealth: Breed.defaultChildCharacteristic(), potentialForWeightGain: Breed.defaultChildCharacteristic(), size: Breed.defaultChildCharacteristic() }),
            trainability: __assign(__assign({}, Breed.defaultParentCharacteristic()), { easyToTrain: Breed.defaultChildCharacteristic(), intelligence: Breed.defaultChildCharacteristic(), potentialForMouthiness: Breed.defaultChildCharacteristic(), preyDrive: Breed.defaultChildCharacteristic(), tendencyToBarkOrHowl: Breed.defaultChildCharacteristic(), wanderlustPotential: Breed.defaultChildCharacteristic() }),
            exerciseNeeds: __assign(__assign({}, Breed.defaultParentCharacteristic()), { energyLevel: Breed.defaultChildCharacteristic(), intensity: Breed.defaultChildCharacteristic(), exerciseNeeds: Breed.defaultChildCharacteristic(), potentialForPlayfulness: Breed.defaultChildCharacteristic() })
        };
    };
    Breed.defaultProps = function (name, size, group) {
        return __assign(__assign({}, common_1.AbstractModel.defaultBaseProps(true, ChangeCase.constantCase(name))), { name: name, description: '', img: '', size: size, breedGroup: group, aliases: [], characteristics: Breed.defaultCharacteristics(), height: {
                high: 0,
                low: 0,
                units: 'in'
            }, weight: {
                high: 0,
                low: 0,
                units: 'lbs'
            }, lifeSpan: {
                high: 0,
                low: 0,
                units: 'years'
            } });
    };
    /**
     * @TOOD STATIC
     */
    Breed.sizeToNum = function (size) {
        switch (size) {
            case profile_1.BreedSize.TOY:
                return 1;
            case profile_1.BreedSize.SMALL:
                return 2;
            case profile_1.BreedSize.MEDIUM:
                return 3;
            case profile_1.BreedSize.LARGE:
                return 4;
            case profile_1.BreedSize.GIANT:
                return 5;
            default:
                throw new Error("Should not have \"" + size + "\"");
        }
    };
    Object.defineProperty(Breed.prototype, "sizeRank", {
        get: function () {
            return Breed.sizeToNum(this.props.size);
        },
        enumerable: false,
        configurable: true
    });
    return Breed;
}(common_1.AbstractModel));
exports.Breed = Breed;
